module.exports = __webpack_public_path__ + "static/media/ThatsIt_Logo.1a3ad7e9.png";